// i18n area 'system' — locale el-GR (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/system.el-GR.meta.json.
import type { enUS } from './system'

export const elGR: typeof enUS = {
  diagnostics: {
    title: 'Διαγνωστικά',
    subtitle: 'Τι πάει στραβά, το χειρότερο πρώτα — ο ίδιος φακός με το tvirt diagnose',
    reload: 'Επαναφόρτωση',
    loadError: 'Η διάγνωση δεν ήταν δυνατόν να διαβαστεί',
    exportBundle: 'Εξαγωγή πακέτου',
    exportError: 'Το πακέτο δεν ήταν δυνατόν να δημιουργηθεί',
    noProblem: 'Κανένα πρόβλημα στις περιοχές που ελέγχθηκαν',
    nothingInspected: 'ΤΙΠΟΤΑ δεν ελέγχθηκε — αυτό δεν είναι πιστοποιητικό υγείας',
    inspected: 'Ελέγχθηκαν',
    notInspected: 'ΔΕΝ ελέγχθηκαν',
    localHint: 'Οι τοπικές περιοχές του κόμβου (μονάδες systemd, journal) διαβάζονται μόνο από το CLI: tvirt diagnose --area local — ο δρόμος όταν το API δεν απαντά.',
    thresholds: 'αποτυχημένες εργασίες εντός {hours} ω, heartbeat καθυστερημένο πάνω από {seconds} δ',
    severity: {
      critical: 'Κρίσιμο',
      warning: 'Προειδοποίηση',
      unknown: 'Άγνωστο'
    }
  },
  explorer: {
    title: 'Εξερεύνηση πόρων',
    root: 'Ρίζα',
    empty: 'Κανένας πόρος σε αυτό το scope',
    previewHint: 'Επιλέξτε ένα αντικείμενο για να δείτε την προεπισκόπησή του',
    open: 'Άνοιγμα',

    // Το deep-link ?scope= των λιστών CRUD (γύρος #109), από την εξερεύνηση (#143).
    openScoped: 'Άνοιγμα της λίστας σε αυτό το scope',
    kinds: {
      vm: 'VM',
      vmTemplate: 'Πρότυπο VM',
      ct: 'CT',
      ctTemplate: 'Πρότυπο CT',
      app: 'App',
      overlayNetwork: 'Δίκτυο overlay',
      networkService: 'Υπηρεσία δικτύου',
      fabric: 'Fabric',
      subnet: 'Subnet',
      storage: 'Pool αποθήκευσης',
      disk: 'Δίσκος',
      catalogFile: 'Αρχείο καταλόγου',
      ociRegistry: 'Μητρώο OCI',
      ociImage: 'Εικόνα OCI',
      cephCluster: 'Συστοιχία Ceph',
      backupDestination: 'Προορισμός backup',
      user: 'Χρήστης',
      group: 'Ομάδα',
      role: 'Ρόλος',
      credential: 'Διαπιστευτήριο',
      tag: 'Ετικέτα',
      proximityRule: 'Κανόνας εγγύτητας'
    }
  },
  tags: {
    title: 'Ετικέτες',
    empty: 'Καμία ετικέτα',
    add: 'Προσθήκη ετικέτας',
    remove: 'Αφαίρεση',
    name: 'Ετικέτα',
    value: 'Τιμή',
    save: 'Αποθήκευση',
    saveError: 'Δεν ήταν δυνατή η αποθήκευση των ετικετών',
    loadError: 'Δεν ήταν δυνατή η φόρτωση του λεξιλογίου των ετικετών',
    noVocabulary: 'Καμία ετικέτα διαθέσιμη για αυτό το είδος πόρου',

    // Μια ετικέτα μονής τιμής ήδη ορισμένη απαντά 409: η αντικατάσταση είναι πάντα
    // ρητή — ποτέ σιωπηρή υποκατάσταση (σχεδίαση, επικυρώθηκε 2026-07-27).
    overwrite: 'Αντικατάσταση της τρέχουσας τιμής',

    // Σύστημα > Ετικέτες, η επιφάνεια του λεξιλογίου.
    createTitle: 'Δημιουργία ετικέτας',
    editTitle: 'Επεξεργασία ετικέτας',
    nameHint: 'Γράμματα, ψηφία, τελείες, παύλες και κάτω παύλες — χωρίς «:» και χωρίς «/»· το πρόθεμα tvirt- είναι δεσμευμένο για την πλατφόρμα',
    cardinality: 'Πληθικότητα',
    cardinalitySingle: 'Μία μόνο τιμή',
    cardinalityMultiple: 'Πολλαπλές τιμές',
    cardinalityHint: 'Με μία μόνο τιμή, η εκ νέου ανάθεση της ετικέτας ζητά την αντικατάστασή της',
    autoCreate: 'Αυτόματη δημιουργία τιμών',
    autoCreateOn: 'Κατά την ανάθεση',
    autoCreateOff: 'Μόνο δηλωμένες',
    autoCreateHint: 'Ενεργό: η ανάθεση μιας νέας τιμής τη δημιουργεί. Ανενεργό: ανατίθενται μόνο οι δηλωμένες τιμές',
    values: 'Τιμές',
    noValues: 'Καμία δηλωμένη τιμή',
    addValue: 'Προσθήκη τιμής',
    duplicateValue: 'Διπλότυπη τιμή',
    kinds: 'Είδη πόρων',
    kindsAll: 'Όλα',
    kindsPlaceholder: 'Όλα',
    kindsHint: 'Αφήστε το κενό για να επιτρέπεται κάθε είδος πόρου που δέχεται ετικέτες',
    systemChip: 'Σύστημα',
    deleteCascade: 'Αφαίρεση και των αναθέσεων',
    deleteCascadeHint: 'Μια ετικέτα που είναι ακόμη ανατεθειμένη σε κάποιον πόρο απορρίπτεται: με αυτή την επιλογή οι τιμές και όλες οι αναθέσεις φεύγουν μαζί με την ετικέτα.'
  },
  scopes: {
    title: 'Scope',
    createTitle: 'Δημιουργία scope',
    editTitle: 'Μετονομασία scope',
    path: 'Διαδρομή',
    segment: 'Τμήμα',
    segmentHint: 'Πεζά γράμματα, ψηφία και παύλες (DNS-1123)',
    parent: 'Γονέας',
    rootChip: 'Ρίζα',
    preview: 'Νέο scope',
    pickLabel: 'Scope',
    pickHint: 'Πού ζει το αντικείμενο στο δέντρο της συστοιχίας — η ρίζα ή ένα vDC μέσα σε αυτήν.',
    ociCache: 'Cache OCI (παράκαμψη)',
    appEphemeral: 'Εφήμερα pool App (παράκαμψη)',
    inherit: 'Κληρονόμηση',
    inheritsFrom: 'Κληρονομεί από',
    inheritsCluster: 'Κληρονομεί την προεπιλογή της συστοιχίας',
    inheritsNone: 'Κληρονομεί — κανένα ισχύον pool',
    failoverProtection: 'Προστασία σε υποβάθμιση',
    networkWeight: 'Βάρος δικτύου',
    networkCeil: 'Όριο δικτύου (Mbps)',
    protectionProtected: 'Προστατευμένο',
    protectionExpendable: 'Αναλώσιμο σε υποβάθμιση',
    protectionDefault: 'Προεπιλογή συστοιχίας'
  },

  // Σύστημα > Πληροφορίες (γύρος #124, 2026-07-31): εκδόσεις της πλατφόρμας
  // στον στόλο (το πολύ δύο στη διάρκεια αναβάθμισης), συνιστώσες ανά κόμβο,
  // εγχειρίδιο PDF που σερβίρεται τοπικά και ενσωματωμένη κάρτα άδειας χρήσης.
  sysinfo: {
    summary: 'Εκδόσεις της πλατφόρμας στη συστοιχία, συνιστώσες κάθε κόμβου, εγχειρίδιο διαχείρισης και άδεια χρήσης.',
    platformTitle: 'Πλατφόρμα TVirt',
    platformSubtitle: 'Εκδόσεις που παρατηρήθηκαν στους κόμβους της συστοιχίας',
    versionOnNodes: '{version} σε {n} κόμβους',
    versionOnOneNode: '{version} σε 1 κόμβο',
    mixedVersions: 'Περισσότερες από μία εκδόσεις της πλατφόρμας στη συστοιχία — αναμενόμενο μόνο όσο βρίσκεται σε εξέλιξη μια αναβάθμιση (το πολύ δύο).',
    tooManyVersions: 'Περισσότερες από δύο εκδόσεις της πλατφόρμας στη συστοιχία — δεν αναμένεται ποτέ, ούτε καν στη διάρκεια μιας αναβάθμισης: ελέγξτε τους κόμβους παρακάτω.',
    unreportedNodes: 'Ακόμη καμία αναφορά εκδόσεων από: {nodes}',
    noVersionsYet: 'Κανένας κόμβος δεν έχει αναφέρει ακόμη τις εκδόσεις του.',
    nodesUnavailable: 'Η λίστα των κόμβων δεν είναι ορατή με τα δικαιώματά σας — δεν είναι δυνατή η εμφάνιση των εκδόσεων της πλατφόρμας.',
    colNode: 'Κόμβος',
    manualTitle: 'Εγχειρίδιο διαχείρισης',
    manualSubtitle: 'Τοπικό αντίγραφο, σερβίρεται από αυτή τη συστοιχία',
    manualBody: 'Το πλήρες εγχειρίδιο TVirt σε PDF, σερβιρισμένο απευθείας από την πλατφόρμα — διαθέσιμο και σε περιβάλλοντα air-gapped.',
    manualLink: 'Εγχειρίδιο διαχείρισης (PDF)',
    apiExplorerTitle: 'Εξερευνητής API',
    apiExplorerSubtitle: 'Το συμβόλαιο OpenAPI, πλοηγήσιμο',
    apiExplorerBody: 'Το πλήρες συμβόλαιο OpenAPI της πλατφόρμας — κάθε διαδρομή, σχήμα και κωδικός απόκρισης — εξερευνήσιμο από τον περιηγητή, σερβιρισμένο μέσω αυτού του κόμβου.',
    apiExplorerLink: 'Εξερεύνηση API',
    kubeTitle: 'Συμβατότητα Kubernetes',
    kubeSubtitle: 'Το kubectl και τα εργαλεία του, μπροστά από το εγγενές API',
    kubeBody: 'Το TVirt KubeCompat προβάλλει Pods, Deployments, Services, namespaces, κόμβους και συμβάντα στη διάλεκτο του Kubernetes — μόνο ανάγνωση, συν τη διαγραφή Deployments. Κάθε κλήση περνά από το εγγενές API με τα δικαιώματά σου: στο kubeconfig χρησιμοποίησε ένα app token ως bearer.',
    kubeEndpoint: 'Endpoint για το kubectl',
    kubeStatusActive: 'Ενεργό — Kubernetes {version}',
    kubeStatusMissing: 'Δεν είναι εγκατεστημένο σε αυτόν τον κόμβο (πακέτο trantor-tvirt-kubecompat)',
    kubeStatusDown: 'Εγκατεστημένο αλλά δεν αποκρίνεται — έλεγξε τη μονάδα trantor-tvirt-kubecompat',
    kubeStatusChecking: 'Έλεγχος…'
  },

  // Licensing (γύρος 2026-07-29): η σελίδα της άδειας χρήσης με συνδρομή.
  licensing: {
    title: 'Άδεια χρήσης της συστοιχίας',
    subtitle: 'Άδεια χρήσης με συνδρομή — το πολύ μία ανά συστοιχία',
    absentTitle: 'Καμία καταχωρημένη άδεια χρήσης',
    absentBody:
      'Χωρίς έγκυρη άδεια χρήσης η συστοιχία αρνείται να εκκινήσει νέες εικονικές μηχανές (οι ενεργές VM παραμένουν ενεργές). Καταχωρίστε το κλειδί προϊόντος που λάβατε με τη συνδρομή σας.',
    registerButton: 'Καταχώριση άδειας χρήσης',
    removeButton: 'Αφαίρεση άδειας χρήσης',
    state: {
      ok: 'Έγκυρη',
      limitExceeded: 'Υπέρβαση ορίου',
      expired: 'Έληξε'
    },
    productKeyLabel: 'Κλειδί προϊόντος',
    basisLabel: 'Βάση του ορίου',
    basis: {
      concurrentVms: 'Ταυτόχρονα ενεργές VM',
      physicalCores: 'Φυσικοί πυρήνες (σύνολο συστοιχίας)'
    },
    limitLabel: 'Όριο',
    usageLabel: 'Τρέχουσα χρήση',
    usageOf: '{used} από {limit}',
    usagePartial: 'μερικό άθροισμα — {n} κόμβος/-οι χωρίς παρατηρημένη τοπολογία CPU',
    usageUnknown: 'μη παρατηρήσιμη αυτήν τη στιγμή',
    expiresLabel: 'Λήξη',
    neverExpires: 'ποτέ',
    registeredLabel: 'Καταχωρήθηκε',
    gateNote:
      'Με άδεια χρήσης απούσα, ληγμένη ή πέραν του ορίου, η συστοιχία αρνείται να εκκινήσει ΝΕΕΣ εικονικές μηχανές. Οι ενεργές VM παραμένουν ενεργές και οι επανεκκινήσεις HA δεν επηρεάζονται.',
    devStage:
      'Φάση ανάπτυξης: το κλειδί προϊόντος γίνεται δεκτό ως έχει, μαζί με τα όρια που δηλώνονται εδώ· η επικύρωση με υπογεγραμμένο κλειδί θα έρθει σε μελλοντική έκδοση.',
    dialogTitle: 'Καταχώριση άδειας χρήσης',
    dialogExpiresHelp: 'Κενό = η άδεια χρήσης δεν λήγει ποτέ',
    dialogSubmit: 'Καταχώριση',
    dialogError: 'Δεν ήταν δυνατή η καταχώριση της άδειας χρήσης.',
    removeTitle: 'Αφαίρεση άδειας χρήσης',
    removeBody:
      'Η συστοιχία θα λειτουργεί ΧΩΡΙΣ ΑΔΕΙΑ ΧΡΗΣΗΣ: οι νέες εικονικές μηχανές θα αρνούνται να εκκινήσουν μέχρι να καταχωρίσετε μία. Οι ενεργές VM παραμένουν ενεργές.',
    removeConfirm: 'Αφαίρεση',
    removeError: 'Δεν ήταν δυνατή η αφαίρεση της άδειας χρήσης.'
  },
  rbac: {
    tabRoles: 'Ρόλοι',
    tabGrants: 'Εκχωρήσεις',
    rolesTitle: 'Ρόλοι',
    createRoleTitle: 'Δημιουργία ρόλου',
    editRoleTitle: 'Επεξεργασία ρόλου',
    nameHint: 'Πεζά γράμματα, ψηφία και παύλες· το πρόθεμα tvirt- είναι δεσμευμένο',
    systemChip: 'Σύστημα',
    permissions: 'Δικαιώματα',
    permissionsPlaceholder: 'Προσθήκη δικαιώματος…',
    includedRoles: 'Περιλαμβανόμενοι ρόλοι',
    includedRolesPlaceholder: 'Προσθήκη ρόλου…',
    grantsTitle: 'Εκχωρήσεις',
    createGrantTitle: 'Δημιουργία εκχώρησης',
    principal: 'Principal',
    principalKind: 'Τύπος principal',
    principalUser: 'Χρήστης',
    principalGroup: 'Ομάδα',
    role: 'Ρόλος',
    grantRight: 'Δικαίωμα εκχώρησης',
    grantRightChip: 'Μπορεί να εκχωρεί',
    grantRightLabel: 'Με δικαίωμα εκχώρησης (ο αποδέκτης μπορεί με τη σειρά του να εκχωρήσει περαιτέρω αυτόν τον ρόλο)',
    effective: 'Σε ισχύ',
    notEffective: 'Εκτός ισχύος',
    createdAt: 'Δημιουργήθηκε',
    scopeHint: '/path ακριβές, /path/* αναδρομικό — οι εκχωρήσεις αγκυρώνονται σε μια προσαρτημένη ρίζα (το /* δεν εκχωρείται)'
  },
  groups: {
    title: 'Ομάδες',
    createTitle: 'Δημιουργία ομάδας',
    nameHint: 'Πεζά γράμματα, ψηφία και παύλες· μοναδικό μέσα στο scope',
    members: 'Μέλη',
    membersTitle: 'Μέλη',
    membersPlaceholder: 'Προσθήκη χρήστη…',
    noMembers: 'Κανένα μέλος',
    realmMappings: 'Αντιστοιχίσεις realm',
    realmMappingsTitle: 'Αντιστοιχίσεις realm',
    realmMappingsHint:
      'Σε τι αντιστοιχεί αυτή η ομάδα σε κάθε εξωτερικό realm. Η ιδιότητα μέλους διαβάζεται από την υπηρεσία καταλόγου κατά τη σύνδεση: μια ομάδα καταλόγου που κανείς δεν αντιστοιχίζει εδώ αγνοείται, και η ένθεση δεν επιλύεται — πρέπει να απλοποιηθεί από την πλευρά του καταλόγου.',
    realm: 'Realm',
    externalGroup: 'Εξωτερική ομάδα',
    addRealmMapping: 'Προσθήκη αντιστοίχισης',
    removeRealmMapping: 'Αφαίρεση αντιστοίχισης',
    noRealmMappings: 'Καμία αντιστοίχιση realm',

    // Διάλογος δημιουργίας σε ενότητες (γύρος realm-wizard, 2026-08-03): Γενικά
    // συν την επιφάνεια αντιστοίχισης με τα εξωτερικά realm, με το εύγλωττο
    // κενό state.
    sectionGeneral: 'Γενικά',
    mappingsNoRealms: 'Δεν έχει διαμορφωθεί κανένα εξωτερικό realm — η επιφάνεια αντιστοίχισης ξεκλειδώνει μόλις υπάρξει ένα realm.',
    mappingsNoRealmsLink: 'Ανοίξτε την καρτέλα «Realm και SSO»',

    // Η υποχρέωση MFA που επιβάλλει η ομάδα (γύρος #178 μισό Β): καθαρό OR —
    // μια ομάδα μπορεί μόνο να ΠΡΟΣΘΕΣΕΙ την υποχρέωση, ποτέ να την άρει.
    mfaRequired: 'Υποχρέωση MFA',
    mfaRequiredChip: 'Επιβάλλει MFA',
    mfaNotRequiredChip: 'Καμία υποχρέωση',
    mfaRequiredHint:
      'Καθαρό OR: μια ομάδα μπορεί να ΠΡΟΣΘΕΣΕΙ την υποχρέωση δεύτερου παράγοντα στα μέλη της — και στις εξωτερικές ταυτότητες, μέσω των αντιστοιχίσεων realm — ποτέ να την άρει. Ισχύει από την επόμενη σύνδεση: οι ανοιχτές συνεδρίες δεν κλείνουν.'
  },
  users: {
    title: 'Χρήστες',
    createTitle: 'Δημιουργία χρήστη',
    editTitle: 'Επεξεργασία χρήστη',
    username: 'Όνομα χρήστη',
    usernameHint: 'Πεζά γράμματα, ψηφία, τελείες και παύλες',
    displayName: 'Εμφανιζόμενο όνομα',
    enabled: 'Ενεργοποιημένος',
    state: 'Κατάσταση',
    enabledChip: 'Ενεργοποιημένος',
    disabledChip: 'Απενεργοποιημένος',
    lockedChip: 'Κλειδωμένος',
    password: 'Κωδικός πρόσβασης',
    passwordSetChip: 'Ορισμένος',
    mustChangeChip: 'Προς αλλαγή',
    initialPassword: 'Αρχικός κωδικός πρόσβασης',
    initialPasswordHint: 'Ο χρήστης θα πρέπει να τον αλλάξει στην πρώτη σύνδεση',
    lastLogin: 'Τελευταία σύνδεση',
    neverLoggedIn: 'Δεν έχει συνδεθεί ποτέ',
    setPasswordTitle: 'Ορισμός κωδικού πρόσβασης',
    setPasswordHint: 'Διαχειριστική αντικατάσταση — απαιτεί τον δικό σας κωδικό πρόσβασης (λειτουργία sudo) και υποχρεώνει τον χρήστη να τον αλλάξει στην επόμενη σύνδεση.',
    operatorPassword: 'Ο κωδικός πρόσβασής σας',
    unlock: 'Ξεκλείδωμα του λογαριασμού',
    revokeTitle: 'Ανάκληση συνεδριών',
    revokeBody: 'Όλες οι ενεργές συνεδρίες αυτού του χρήστη τερματίζονται αμέσως.',
    revokeIncludeTokens: 'Ανάκληση και των διακριτικών εφαρμογής',
    revokeConfirm: 'Ανάκληση',

    // Τυπικός διάλογος (γύρος #156): πλήρη στοιχεία, καρτέλες λογαριασμός/ασφάλεια.
    tabAccount: 'Λογαριασμός',
    tabSecurity: 'Ασφάλεια',
    usernameImmutableHint: 'Το όνομα χρήστη είναι η ταυτότητα του λογαριασμού — ορίζεται οριστικά κατά τη δημιουργία',
    groups: 'Ομάδες',
    noGroups: 'Καμία ομάδα',
    mustChangePassword: 'Υποχρεωτική αλλαγή κωδικού πρόσβασης',
    failedAttempts: 'Αποτυχημένες απόπειρες σύνδεσης',
    lockedUntil: 'Κλειδωμένος έως',

    // Καρτέλες ταυτότητας (2026-08-03): το Σύστημα > Χρήστες έγινε ενότητα με
    // καρτέλες στο μοντέλο του /system/rbac — χρήστες, ομάδες, εξωτερικά realm.
    tabUsers: 'Χρήστες',
    tabGroups: 'Ομάδες',
    tabRealms: 'Realm και SSO',
    tabMfa: 'MFA',

    // Καρτέλα MFA (εργασία #178): η προβολή του δεύτερου παράγοντα. Μισό Α — ο
    // πίνακας ανά χρήστη πάνω στο users.yaml· μισό Β (γύρος contract, επικυρώσεις
    // 2026-08-04) — η ισχύουσα ετυμηγορία με την προέλευσή της, οι εξωτερικές
    // εγγραφές με την ορφανή κατάσταση και οι ομάδες που επιβάλλουν την υποχρέωση.
    mfa: {
      title: 'Δεύτερος παράγοντας (MFA)',
      methodsTitle: 'Διαθέσιμες μέθοδοι',
      methodsSubtitle: 'Ό,τι αυτή η εγκατάσταση μπορεί να επαληθεύσει ως δεύτερο παράγοντα',
      methodsError: 'Δεν ήταν δυνατή η φόρτωση του μητρώου των μεθόδων',
      builtinChip: 'Ενσωματωμένη',
      enrollableChip: 'Εγγραφή στο TVirt',
      delegatedChip: 'Εξωτερική διαχείριση',
      state: 'Κατάσταση',
      stateActive: 'Ενεργό',
      statePending: 'Σε αναμονή εγγραφής',
      stateNone: 'Χωρίς εγγραφή',
      required: 'Υποχρέωση MFA',
      requiredChip: 'Υποχρεωτικό',
      notRequiredChip: 'Μη υποχρεωτικό',
      enrolledAt: 'Εγγραφή στις',
      enrolledMethods: 'Εγγεγραμμένες μέθοδοι',
      noMethods: 'Καμία εγγραφή',
      codesRemaining: 'Υπολειπόμενοι κωδικοί ανάκτησης',
      resetTitle: 'Επαναφορά του δεύτερου παράγοντα',
      resetHint:
        'Η εγγραφή και όλοι οι κωδικοί ανάκτησης μηδενίζονται: στην επόμενη σύνδεση ο χρήστης θα κάνει την εγγραφή ξανά από την αρχή. Η υποχρέωση MFA μένει ως έχει — ένας διαχειριστής δεν ορίζει ποτέ ένα μυστικό, μόνο το μηδενίζει.',
      resetConfirm: 'Επαναφορά',
      resetError: 'Δεν ήταν δυνατή η επαναφορά του δεύτερου παράγοντα',
      empty: 'Κανένας διαχειριζόμενος χρήστης ακόμη — οι λογαριασμοί εμφανίζονται εδώ μόλις υπάρξουν, καθένας με την κατάσταση του δεύτερου παράγοντά του.',

      // Μισό Β (γύρος #178): προέλευση της ισχύουσας ετυμηγορίας, εξωτερικές
      // εγγραφές με την ορφανή κατάσταση, ομάδες που επιβάλλουν την υποχρέωση.
      viaSelf: 'Προσωπικό',
      viaSelfHint: 'Η προσωπική συνεισφορά του λογαριασμού (η σημαία του) — το μόνο μέρος που επεξεργάζεται το μολύβι.',
      viaGroupHint: 'Υποχρέωση κληρονομημένη από αυτήν την ομάδα: η αφαίρεση της προσωπικής σημαίας δεν απελευθερώνει τον χρήστη — η παρέμβαση γίνεται στην ομάδα, στην καρτέλα «Ομάδες».',
      subject: 'Ταυτότητα',
      lastSeenAt: 'Τελευταία επιβεβαίωση',
      enrollmentPending: 'Σε εκκρεμότητα',
      orphanChip: 'Ορφανή',
      orphanDirectoryMiss: 'Η ταυτότητα δεν βρίσκεται πλέον στην υπηρεσία καταλόγου',
      orphanRealmRemoved: 'Το realm αφαιρέθηκε από το TVirt',
      orphanedAt: 'Ορφανή από',
      directoryUuid: 'UUID στην υπηρεσία καταλόγου',
      externalTitle: 'Εξωτερικές εγγραφές',
      externalEmpty: 'Καμία εξωτερική εγγραφή ακόμη — γεννιέται στην πρώτη σύνδεση μιας ταυτότητας καταλόγου με υποχρέωση MFA.',
      orphanHelp:
        'Μια ορφανή εγγραφή δεν διαγράφεται ποτέ από μόνη της: είναι υλικό ασφαλείας — μένει για το audit και, αν η ταυτότητα επανεμφανιστεί στην υπηρεσία καταλόγου, ξαναβρίσκει τον παράγοντά της. Η μόνη έξοδος είναι η διαχειριστική επαναφορά.',
      visibilityHint: 'Οι εξωτερικές εγγραφές βρίσκονται στη ρίζα της συστοιχίας: τις βλέπει μόνο όποιος έχει user.read σε ολόκληρο το δέντρο.',
      orphanResetHint:
        'Η ορφανή γραμμή αφαιρείται οριστικά: κανείς δεν τη διεκδικεί πια. Αν η ταυτότητα επανεμφανιστεί στην υπηρεσία καταλόγου, θα κάνει την εγγραφή ξανά από την αρχή.',
      enforcingTitle: 'Ομάδες που επιβάλλουν MFA',
      enforcingSubtitle:
        'Η άγκυρα της υποχρέωσης για τις εξωτερικές ταυτότητες είναι η ομάδα: οι αντιστοιχίσεις realm της λένε σε ποιον πληθυσμό του καταλόγου φτάνει. Η εξωτερική εγγραφή γεννιέται στην πρώτη σύνδεση του υπόχρεου χρήστη.',
      enforcingEmpty: 'Καμία ομάδα δεν επιβάλλει MFA — η υποχρέωση ενεργοποιείται στην ομάδα, από την καρτέλα «Ομάδες».',
      enforcingError: 'Δεν ήταν δυνατή η φόρτωση των ομάδων που επιβάλλουν MFA'
    }
  },
  realms: {
    title: 'Realm ελέγχου ταυτότητας',
    createTitle: 'Δημιουργία realm',
    editTitle: 'Επεξεργασία realm',
    name: 'Realm',
    nameHint: 'Ο τομέας που πληκτρολογούν οι χρήστες μετά το @ (example.com) — αμετάβλητος μετά τη δημιουργία',
    nameImmutableHint: 'Το όνομα του realm αποτυπώνεται σε κάθε συνεδρία και σε κάθε γραμμή audit που το ανέφερε ποτέ — η μετονομασία θα ξανάγραφε την ιστορία',
    kind: 'Τύπος',
    kindLdap: 'LDAP / Active Directory',
    kindHint: 'Τα OIDC και SAML έρχονται στους επόμενους γύρους — σήμερα ένα realm είναι ένας κατάλογος LDAPv3',

    // Ημι-οδηγός δημιουργίας (γύρος realm-wizard, 2026-08-03): οι κάρτες τύπων
    // του βήματος 1 — ldap ζωντανό, oidc/saml κάρτες σε roadmap (ποτέ μια φόρμα
    // χωρίς backend από πίσω).
    kindCategory: 'Τύπος realm',
    kindSelectHint: 'Επιλέξτε τον τύπο καταλόγου στον οποίο θα κάνει έλεγχο ταυτότητας αυτό το realm.',
    kindCard: {
      ldap: {
        name: 'LDAP / Active Directory',
        desc: 'Όνομα χρήστη και κωδικός πρόσβασης που επαληθεύονται με ένα bind σε έναν κατάλογο LDAPv3 — Active Directory, FreeIPA, OpenLDAP.'
      },
      oidc: {
        name: 'OpenID Connect',
        desc: 'Single sign-on από το πρόγραμμα περιήγησης, ανατεθειμένο σε έναν πάροχο ταυτότητας OpenID Connect — έρχεται στους επόμενους γύρους.'
      },
      saml: {
        name: 'SAML 2.0',
        desc: 'Εταιρικό single sign-on με δηλώσεις SAML 2.0 — έρχεται στους επόμενους γύρους.'
      }
    },
    tabBind: 'Bind',
    enabled: 'Ενεργοποιημένο',
    urls: 'Διακομιστές του καταλόγου',
    urlsHint: 'Ένα URL ldap:// ή ldaps:// ανά γραμμή (1–8), δοκιμάζονται με τη σειρά — failover, ποτέ εξισορρόπηση',
    startTls: 'StartTLS',
    verifyCertificate: 'Επαλήθευση του πιστοποιητικού',
    cleartextWarning: 'Χωρίς ldaps:// ή StartTLS ο κωδικός πρόσβασης του bind διασχίζει το δίκτυο σε καθαρό κείμενο — αποδεκτό σε εργαστήριο, ποτέ σε παραγωγή.',
    noVerifyWarning: 'Μια μη επαληθευμένη συνεδρία TLS δεν ελέγχει την ταυτότητα κανενός: απενεργοποιήστε την επαλήθευση μόνο απέναντι σε έναν κατάλογο που δεν μπορείτε να διορθώσετε.',
    caCertificate: 'Πιστοποιητικό CA (PEM)',
    caCertificateHint: 'Προαιρετικό bundle CA καρφιτσωμένο για τη χειραψία TLS/StartTLS αυτού του realm· κενό το αφαιρεί',
    caCertificatePinned: 'Καρφιτσωμένο',
    connectTimeout: 'Timeout (δευτερόλεπτα)',
    connectTimeoutHint: 'Προθεσμία σύνδεσης και αιτήματος ανά URL (1–60)· με τη λήξη της δοκιμάζεται το επόμενο URL',
    bindDn: 'Bind DN',
    bindDnHint: 'Ο λογαριασμός υπηρεσίας που εκτελεί την αναζήτηση του χρήστη· κενό = ανώνυμο search bind (απορρίπτεται από το AD)',
    anonymousBind: 'Ανώνυμο search bind',
    bindCredential: 'Κωδικός πρόσβασης bind (αποθήκη κλειδιών)',
    bindCredentialHint: 'Μια καταχώριση usernamePassword της αποθήκης κλειδιών με τον κωδικό πρόσβασης του bind — το μυστικό δεν ζει ποτέ πάνω στο realm',
    bindCredentialNone: 'Καμία (ανώνυμο bind)',
    bindCredentialEmpty: 'Καμία καταχώριση usernamePassword στην αποθήκη κλειδιών — δημιουργήστε μία στο Σύστημα > Διαπιστευτήρια για τον κωδικό πρόσβασης του bind.',
    baseDn: 'Base DN',
    baseDnHint: 'Το υποδέντρο από το οποίο ξεκινά η αναζήτηση του χρήστη (DC=example,DC=com)',
    userFilter: 'Φίλτρο χρήστη',
    userFilterHint: 'Το %u αντικαθίσταται από το τοπικό μέρος της σύνδεσης, με διαφυγή RFC 4515· οι κατάλογοι εκτός AD τυπικά θέλουν (&(objectClass=inetOrgPerson)(uid=%u))',
    memberOfAttribute: 'Χαρακτηριστικό memberOf',
    memberOfAttributeHint: 'Διαβάζεται μία μόνο φορά, κατά τη σύνδεση — οι μη αντιστοιχισμένες ομάδες αγνοούνται, η ένθεση δεν επιλύεται',
    uuidAttribute: 'Χαρακτηριστικό UUID',
    uuidAttributeHint: 'Το αμετάβλητο UUID μέσα στο realm (objectGUID σε AD, entryUUID σε OpenLDAP) — αποτυπώνεται στο audit δίπλα στο χρήστης@realm',
    displayNameAttribute: 'Χαρακτηριστικό εμφανιζόμενου ονόματος',
    displayNameAttributeHint: 'Χρησιμοποιείται για τον χαιρετισμό του χρήστη· ελλείψει αυτού χρησιμοποιείται το όνομα σύνδεσης',
    sudoHint: 'Οι τροποποιήσεις των realm είναι προστατευμένες με sudo: ένα realm είναι μια πόρτα εισόδου στην πλατφόρμα',
    deleteBody: 'Οι αντιστοιχίσεις ομάδων του realm φεύγουν μαζί του· οι συνεδρίες των οποίων έκανε τον έλεγχο ταυτότητας παραμένουν ζωντανές έως τη λήξη τους — ένα διαγραμμένο realm απλώς δεν δέχεται πλέον κανέναν.',
    tabConnection: 'Σύνδεση',
    tabDirectory: 'Κατάλογος LDAP',
    testTitle: 'Δοκιμή σύνδεσης',
    testHint: 'Ένας διαγνωστικός έλεγχος της διαμόρφωσης, ποτέ έλεγχος ταυτότητας: συνδέεται, κάνει bind με τον λογαριασμό υπηρεσίας και — με ένα όνομα χρήστη — εκτελεί το φίλτρο χρήστη.',
    testUsername: 'Όνομα χρήστη (προαιρετικό)',
    testUsernameHint: 'Ένα τοπικό μέρος πάνω στο οποίο θα εκτελεστεί το φίλτρο χρήστη — 1 αντιστοιχία είναι η υγιής απάντηση',
    testRun: 'Εκτέλεση δοκιμής',
    testError: 'Δεν ήταν δυνατή η εκτέλεση του διαγνωστικού ελέγχου',
    testReachable: 'Κατάλογος LDAP προσβάσιμος, bind υπηρεσίας αποδεκτό',
    testUnreachable: 'Κατάλογος LDAP ΜΗ προσβάσιμος',
    matchedOne: 'Το φίλτρο χρήστη βρήκε ακριβώς 1 καταχώριση — η υγιής απάντηση.',
    matchedNone: 'Το φίλτρο χρήστη δεν βρήκε καμία καταχώριση: το φίλτρο ή το base DN είναι λάθος.',
    matchedMany: 'Το φίλτρο χρήστη βρήκε {count} καταχωρίσεις: δεν είναι επιλεκτικό, και οι συνδέσεις θα ήταν αμφίσημες (απορρίπτονται).',
    mappingsPointer: 'Το σε τι αντιστοιχεί μια εξωτερική ομάδα είναι ιδιότητα της ομάδας TVirt (οι αντιστοιχίσεις realm της): το σημείο της αλήθειας ζει στην καρτέλα «Ομάδες».',
    mappingsPointerLink: 'Ανοίξτε την καρτέλα «Ομάδες»',
    rootHomeHint: 'Οι ταυτότητες ενός εξωτερικού realm ζουν στη ρίζα της συστοιχίας, ποτέ σε ένα vDC: τα δικαιώματα ανατίθενται εκεί όπου χρειάζονται, με εκχωρήσεις — στην ομάδα ή απευθείας στον χρήστη, ακριβώς όπως για τους εγγενείς χρήστες.'
  },
  credentials: {
    title: 'Διαπιστευτήρια',
    createTitle: 'Δημιουργία διαπιστευτηρίου',
    editTitle: 'Επεξεργασία διαπιστευτηρίου',
    kind: 'Τύπος',
    kindUsernamePassword: 'Όνομα χρήστη και κωδικός πρόσβασης',
    kindIscsiChap: 'CHAP (iSCSI)',
    kindNvmeDhchap: 'DH-HMAC-CHAP (NVMe)',
    kindCephx: 'cephx (ταυτότητα Ceph)',
    kindHintUsernamePassword: 'Αμετάβλητο. Για τους χώρους αποθήκευσης CIFS/SMB — ο λογαριασμός mount του οποίου το μυστικό χρησιμοποιεί ο worker τη στιγμή του mount.',
    kindHintIscsiChap: 'Αμετάβλητο. Για τον έλεγχο ταυτότητας CHAP του iSCSI — username = όνομα CHAP, secret = μυστικό CHAP.',
    kindHintNvmeDhchap: 'Αμετάβλητο. Για το DH-HMAC-CHAP του NVMe over Fabrics — secret = το blob DHHC-1:xx:…· το username είναι απλώς μια ετικέτα.',
    kindHintCephx: 'Αμετάβλητο. Για τους πελάτες Ceph — username = όνομα πελάτη (client.…), secret = το κλειδί base64.',
    kindImmutableHint: 'Ο τύπος είναι αμετάβλητος μετά τη δημιουργία — η αλλαγή του σημαίνει νέο διαπιστευτήριο.',
    username: 'Όνομα χρήστη',
    usernameChap: 'Όνομα CHAP',
    usernameNvme: 'Ετικέτα',
    usernameCephx: 'Όνομα πελάτη',
    usernameHint: 'Προαιρετικός λογαριασμός στον οποίο ανήκει το μυστικό',
    usernameHintChap: 'Το όνομα CHAP με το οποίο κάνει έλεγχο ταυτότητας ο initiator',
    usernameHintNvme: 'Δεν χρησιμοποιείται από τη μεταφορά — μια ελεύθερη ετικέτα για τις σημειώσεις σας',
    usernameHintCephx: 'Το όνομα πελάτη cephx — το πρόθεμα client. είναι ανεκτό',
    secret: 'Μυστικό',
    secretHint: 'Μόνο για εγγραφή: χρησιμοποιείται από τους καταναλωτές, δεν εμφανίζεται ποτέ ξανά.',
    secretHintNvmeDhchap: 'Μόνο για εγγραφή: το μυστικό DH-HMAC-CHAP του host στην κανονική μορφή DHHC-1:xx:… — χρησιμοποιείται από τους καταναλωτές, δεν εμφανίζεται ποτέ ξανά.',
    secretHintCephx: 'Μόνο για εγγραφή: το κλειδί cephx base64 — χρησιμοποιείται από τους καταναλωτές, δεν εμφανίζεται ποτέ ξανά.',
    secretEditHint: 'Αφήστε το κενό για να διατηρηθεί το τρέχον μυστικό — η συμπλήρωσή του κάνει εναλλαγή.',
    createdAt: 'Δημιουργήθηκε',
    inUseError: 'Το «{name}» αναφέρεται από τη διαμόρφωση ενός χώρου αποθήκευσης — αποσυνδέστε το πρώτα εκεί.',
    nameHint: 'Πεζά γράμματα, ψηφία και παύλες (DNS-1123)· μοναδικό ανά scope',

    // Διάλογος μόνο εναλλαγής (γύρος #156): το μυστικό δεν έχει ποτέ inline μολύβι.
    rotateTitle: 'Εναλλαγή μυστικού',
    rotateHint: 'Μόνο για εγγραφή: το νέο μυστικό αντικαθιστά το αποθηκευμένο — οι καταναλωτές θα το χρησιμοποιήσουν στο επόμενο mount.',

    // Γύρος #159 (PKI): οι καρτέλες Πιστοποιητικά και CA.
    tabSecrets: 'Μυστικά',
    tabCertificates: 'Πιστοποιητικά',
    tabAuthorities: 'Αρχές πιστοποίησης',
    certificatesTitle: 'Πιστοποιητικά',
    authoritiesTitle: 'Αρχές πιστοποίησης',
    caCreateTitle: 'Νέα CA',
    certCreateTitle: 'Νέο πιστοποιητικό',
    caMode: 'Προέλευση',
    caModeGenerate: 'Δημιουργία με το TVirt',
    caModeImport: 'Εισαγωγή (κλειδί + πιστοποιητικό)',
    certMode: 'Προέλευση',
    certModeIssue: 'Έκδοση από μια CA της αποθήκης κλειδιών',
    certModeImport: 'Εισαγωγή (κλειδί + πιστοποιητικό)',
    issuingCa: 'Εκδίδουσα CA',
    issuingCaHint: 'Το πιστοποιητικό γεννιέται στο scope της CA, με καταγεγραμμένο τον γονέα',
    noCasHint: 'Καμία CA στην αποθήκη κλειδιών — δημιουργήστε ή εισαγάγετε πρώτα μία στην καρτέλα «CA»',
    commonName: 'Common name (CN)',
    commonNameCaHint: 'Το subject της CA: γράμματα, ψηφία, κενό, τελεία, κάτω παύλα, παύλα',
    commonNameCertHint: 'Το OpenVPN αναγνωρίζει τους πελάτες από το CN — κρατήστε το μοναδικό ανά CA',
    days: 'Διάρκεια ισχύος (ημέρες)',
    daysCaHint: '1–7300 ημέρες· 3650 (10 χρόνια) είναι η προεπιλογή',
    daysCertHint: '1–3650 ημέρες· 365 είναι η προεπιλογή',
    keyType: 'Τύπος κλειδιού',
    keyTypeHint: 'Το EC P-256 είναι η προεπιλογή· RSA για καταναλωτές παλαιού τύπου',
    usage: 'Χρήση',
    usageClient: 'Πελάτης (clientAuth)',
    usageServer: 'Διακομιστής (serverAuth)',
    usageHint: 'Το extended key usage για το οποίο εκδίδεται το πιστοποιητικό',
    san: 'Εναλλακτικά ονόματα (SAN)',
    sanHint: 'Διαχωρισμένα με κόμμα· τα κυριολεκτικά IP γίνονται καταχωρίσεις IP:, τα υπόλοιπα DNS:',
    keyPem: 'Ιδιωτικό κλειδί (PEM)',
    keyPemHint: 'Μόνο για εγγραφή: φυλάσσεται στην αποθήκη κλειδιών, δεν εμφανίζεται ποτέ ξανά',
    certPem: 'Πιστοποιητικό (PEM)',
    certPemHint: 'Το δημόσιο πιστοποιητικό που ζευγαρώνει με το κλειδί',
    certPemCaHint: 'Το πιστοποιητικό CA που ζευγαρώνει με το κλειδί (basicConstraints CA)',
    subject: 'Subject',
    issuer: 'Εκδότης',
    parentCa: 'Εκδίδουσα CA',
    parentCaImported: 'Εισηγμένο — εκδόθηκε εκτός TVirt',
    serial: 'Σειριακός αριθμός',
    fingerprint: 'Αποτύπωμα (SHA-256)',
    validFrom: 'Έγκυρο από',
    validUntil: 'Έγκυρο έως',
    expiry: 'Λήξη',
    expired: 'Έληξε',
    expiresInDays: 'Λήγει σε {days} ημ.',
    revoked: 'Ανακλήθηκε',
    revokedAtLabel: 'Ανακλήθηκε στις',
    revokeTitle: 'Ανάκληση πιστοποιητικού',
    revokeAction: 'Ανάκληση',
    revokeWarning: 'Η ανάκληση είναι οριστική: ο σειριακός αριθμός μπαίνει στο CRL της εκδίδουσας CA και κάθε καταναλωτής που απορρίπτει τα ανακληθέντα πιστοποιητικά (πρωτίστως το OpenVPN) θα απορρίψει αυτό εδώ. Δεν υπάρχει un-revoke.',
    exportPem: 'Εξαγωγή PEM',
    exportChain: 'Εξαγωγή bundle αλυσίδας',
    exportCrl: 'Εξαγωγή CRL',
    materialImmutableHint: 'Το υλικό X.509 είναι αμετάβλητο — επανεκδώστε ή επανεισαγάγετε',
    caInUseError: 'Το «{name}» έχει ακόμη ζωντανά εκδοθέντα πιστοποιητικά (ή το αναφέρει ένας χώρος αποθήκευσης) — πρώτα ανακαλέστε ή διαγράψτε τα.'
  },
  proximity: {
    title: 'TVirt Proximity',
    subtitle: 'Τοποθέτηση, διαθεσιμότητα και συνάφεια — πού εκτελούνται οι VM της συστοιχίας και αν πρέπει να είναι ενεργές',
    loadError: 'Ο πίνακας Proximity χρειάζεται την αποθήκη της συστοιχίας — η κατάσταση του στόλου δεν είναι προσβάσιμη αυτήν τη στιγμή',
    config: {
      title: 'Διαμόρφωση',
      subtitle: 'Πολιτική τοποθέτησης σε επίπεδο συστοιχίας',
      save: 'Αποθήκευση',
      saveError: 'Η διαμόρφωση απορρίφθηκε',
      strategy: 'Στρατηγική επιλογής',
      strategy_leastUsedResources: 'Λιγότερο χρησιμοποιημένοι πόροι',
      strategy_leastVms: 'Λιγότερες VM',
      strategy_random: 'Τυχαία',
      strategyLeastUsedResourcesHint: 'Ανάμεσα στους έγκυρους υποψήφιους, ο κόμβος με την περισσότερη εναπομένουσα αξιοποιήσιμη RAM (παρατηρημένο σύνολο − κράτηση host − ενεργές VM), με τη δέσμευση vCPU ως κριτήριο ισοπαλίας. Ντετερμινιστική με ίδια δεδομένα.',
      strategyLeastVmsHint: 'Ανάμεσα στους έγκυρους υποψήφιους, ο κόμβος με τις λιγότερες ενεργές VM· οι ισοπαλίες λύνονται με το όνομα του κόμβου. Ντετερμινιστική με ίδια δεδομένα.',
      strategyRandomHint: 'Ομοιόμορφα τυχαία ανάμεσα στους έγκυρους υποψήφιους.',
      liveness: 'Κατώφλι ζωτικότητας των κόμβων (δευτερόλεπτα)',
      livenessHint: 'Ένα μέλος σιωπηλό πέρα από το κατώφλι είναι μη προσβάσιμο: αποκλείεται από την τοποθέτηση και — αν δεν βρίσκεται σε συντήρηση — θεωρείται νεκρό από τον decider HA, που το περιφράσσει και επανεκκινεί αλλού τις HA VM του.',
      decider: 'Decider HA',
      deciderNone: 'δεν έχει εκλεγεί ακόμη'
    },
    nodesTitle: 'Κόμβοι',
    nodesSubtitle: 'Ζωτικότητα και εμπειρική χωρητικότητα — αξιοποιήσιμη RAM = σύνολο − βάση − δεσμευμένη',
    nodeCol: 'Κόμβος',
    stateCol: 'Κατάσταση',
    ramCol: 'RAM (σύνολο − βάση − δεσμευμένη)',
    usableCol: 'Αξιοποιήσιμη',
    vmsCol: 'Φορτίο',
    neverSeen: 'δεν εθεάθη ποτέ',
    freshChip: 'προσβάσιμος',
    staleChip: 'μη προσβάσιμος',
    attestedChip: 'βεβαιωμένα απενεργοποιημένος',
    ramFormula: 'σύνολο − βάση − δεσμευμένη',
    haTitle: 'Υψηλή διαθεσιμότητα',
    haSubtitle: 'Οι VM με σημαία HA είναι «πάντα ενεργές»: το TVirt τις επανεκκινεί μετά από κάθε διακοπή που δεν ζητήθηκε — ίδιος κόμβος με backoff, άλλος κόμβος όταν ο δικός τους πεθάνει (μόνο με κοινόχρηστη αποθήκευση).',
    haNone: 'Καμία VM δεν έχει ακόμη τη σημαία HA — ενεργοποιήστε την εδώ ή στη λεπτομέρεια της VM.',
    haVmCol: 'Εικονική μηχανή',
    haStateCol: 'Κατάσταση',
    haRestartsCol: 'Επανεκκινήσεις HA',
    haLastEventCol: 'Τελευταίο συμβάν',
    haToggleCol: 'HA',
    haCrashLoop: 'crash loop',
    haToggleError: 'Η αλλαγή HA απορρίφθηκε',
    rules: {
      title: 'Κανόνες συνάφειας',
      createTitle: 'Νέος κανόνας εγγύτητας',
      editTitle: 'Επεξεργασία κανόνα',
      nameHint: 'Πεζά γράμματα, ψηφία και παύλες (ετικέτα DNS)',
      vms: 'Εικονικές μηχανές',
      vmsHint: 'Τουλάχιστον δύο VM — ο κανόνας δεσμεύει το πού εκτελούνται η μία σε σχέση με την άλλη',
      type: 'Τύπος',
      affinity: 'Συνάφεια (μαζί)',
      antiAffinity: 'Αντισυνάφεια (χωριστά)',
      typeAffinityHint: 'Οι VM πρέπει να εκτελούνται στον ΙΔΙΟ κόμβο.',
      typeAntiAffinityHint: 'Οι VM πρέπει να εκτελούνται σε ΔΙΑΦΟΡΕΤΙΚΟΥΣ κόμβους — το κλασικό ζεύγος HA.',
      mode: 'Λειτουργία',
      hard: 'hard',
      soft: 'soft',
      modeHardHint: 'Οι παραβιάσεις απορρίπτουν την ενέργεια (εκκίνηση, μετεγκατάσταση, failover) με ένα εύγλωττο σφάλμα.',
      modeSoftHint: 'Προτίμηση, ποτέ φραγμός: μια τοποθέτηση σε παραβίαση προχωρά με μια ορατή προειδοποίηση.',
      satisfied: 'Τοποθέτηση',
      satisfiedYes: 'τηρείται',
      satisfiedNo: 'παραβιάζεται',

      // Τυπικός διάλογος (γύρος #156): οι παραβιάσεις έχουν δική τους γραμμή, όχι tooltip.
      violations: 'Παραβιάσεις',
      noViolations: 'Καμία'
    },
    events: {
      title: 'Συμβάντα HA',
      subtitle: 'Το ημερολόγιο της διαθεσιμότητας — επανεκκινήσεις, περιφράξεις, failover και οι έντιμες παραλείψεις',
      none: 'Τίποτα ακόμη.',
      when: 'Πότε',
      kind: 'Συμβάν',
      target: 'Στόχος',
      detail: 'Λεπτομέρεια',
      kindRestarted: 'επανεκκίνηση HA',
      kindGaveUp: 'παραίτηση (crash loop)',
      kindNodeAttested: 'κόμβος περιφραγμένος',
      kindFailedOver: 'failover',
      kindNoCandidate: 'κανένας υποψήφιος',
      kindStorageLocalSkip: 'παραλείφθηκε (τοπική αποθήκευση)',
      kindZombieFenced: 'zombie τερματισμένο'
    }
  }
}
